/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface LogCarrierEmailRequest
 */
export interface LogCarrierEmailRequest {
  /**
   *
   * @type {string}
   * @memberof LogCarrierEmailRequest
   */
  carrierIdentifier: string;
  /**
   *
   * @type {string}
   * @memberof LogCarrierEmailRequest
   */
  messageId: string;
  /**
   *
   * @type {boolean}
   * @memberof LogCarrierEmailRequest
   */
  includeThread: boolean;
}

/**
 * Check if a given object implements the LogCarrierEmailRequest interface.
 */
export function instanceOfLogCarrierEmailRequest(
  value: object,
): value is LogCarrierEmailRequest {
  if (
    !("carrierIdentifier" in value) ||
    value["carrierIdentifier"] === undefined
  )
    return false;
  if (!("messageId" in value) || value["messageId"] === undefined) return false;
  if (!("includeThread" in value) || value["includeThread"] === undefined)
    return false;
  return true;
}

export function LogCarrierEmailRequestFromJSON(
  json: any,
): LogCarrierEmailRequest {
  return LogCarrierEmailRequestFromJSONTyped(json, false);
}

export function LogCarrierEmailRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LogCarrierEmailRequest {
  if (json == null) {
    return json;
  }
  return {
    carrierIdentifier: json["carrierIdentifier"],
    messageId: json["messageId"],
    includeThread: json["includeThread"],
  };
}

export function LogCarrierEmailRequestToJSON(
  json: any,
): LogCarrierEmailRequest {
  return LogCarrierEmailRequestToJSONTyped(json, false);
}

export function LogCarrierEmailRequestToJSONTyped(
  value?: LogCarrierEmailRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierIdentifier: value["carrierIdentifier"],
    messageId: value["messageId"],
    includeThread: value["includeThread"],
  };
}
